import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class MenuResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  store(data) {
    // eslint-disable-next-line no-param-reassign
    delete data.controlador_id;
    return this.http.post(this.resource, data);
  }

  update(data, id) {
    // eslint-disable-next-line no-param-reassign
    delete data.controlador_id;
    return this.http.put(`${this.resource}/${id}`, data);
  }
}

const resource = 'menu';

const menuHttp = new MenuResourceHttp(clientHttp, prefixBase + resource);

export default menuHttp;
